

const filterPXQualifiedTemplates = (template) => {var _template$properties, _template$properties2;return (
    ((_template$properties = template.properties) === null || _template$properties === void 0 ? void 0 : _template$properties.some(({ type }) => type === 'markdown')) && ((_template$properties2 =
    template.properties) === null || _template$properties2 === void 0 ? void 0 : _template$properties2.some(({ type }) => type === 'numeric')));};

export { filterPXQualifiedTemplates };